import { apiFetch } from './apiFetch';

export async function paymentCallback(query) {
  try {
    const response = await apiFetch('/payment/callback', {
      method: 'POST',
      redirect: 'manual',
      body: JSON.stringify({
        trans_back: {
          reservation_code: query?.get('Authority'),
          status: query?.get('Status') == 'OK' ? 2 : 3,
        },
      }),
    });
    const data = await response.json().catch(() => ({}));
    return data.redirect_url;
  } catch (error) {
    console.error('Error paying payment: ', error);
    throw error;
  }
}
